import { PaletteProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: PaletteProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as PaletteProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      fill: [
        'rgb(50, 132, 144)',
        'rgb(50, 183, 198)',
        'rgb(146, 224, 225)',
        'rgb(203, 246, 255)',
        'rgb(229, 250, 248)',
      ],
    } as PaletteProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
